import { NotificationFormValuesType } from '@app/modules/notification/forms/notification-form/notification-form.model';
import { NotificationEntityConfig }   from '@app/modules/notification/presets/notification-entity-config.model';
import { INotificationEntityEvents }  from '@core/interfaces/entity.interface';
import { EntityActionEventEnum }      from '@models/entity.model';
import { LanguagesSupportedType }     from '@models/language';

// ENUMS #############################################################
// API enums *********************************************************
export enum NotificationMultiLanguageDataFieldEnum {
	MESSAGE = 'message',
	SUBJECT = 'subject'
}

export enum NotificationTargetTypeEnum {
	ALL = 'all',
	BUSINESS_PREMISES = 'businessPremises',
	ORGANIZATION = 'organization',
	TENANT = 'tenant'
}


// UI enums *********************************************************
export enum NotificationPresetEnum {
	NOTIFICATION = 'notification',
	TASK_CENTER_NOTIFICATIONS = 'taskCenterNotifications',
}

export enum NotificationTagEnum {
	READ = 'read'
}

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************
export interface INotificationEntityActionEvent {
	action: EntityActionEventEnum;
	notification: NotificationTypes;
	notificationEntityConfig: NotificationEntityConfig;
}


// TYPES #############################################################
export type NotificationProp = ( keyof Notification | keyof NotificationAdmin );
export type NotificationProps = NotificationProp[];
export type NotificationTypes =
	Notification
	| NotificationAdmin;


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class NotificationLanguages implements LanguagesSupportedType {
	public de: string = undefined;
	public en: string = undefined;

	[ key: string ]: string;
}


class NotificationBase {
	public businessPremisesId?: string = undefined;
	public confirmedBy?: string = undefined;
	public confirmedDate?: Date = undefined;
	public notificationDate?: Date = undefined;
	public id: string = undefined;
	public message?: NotificationLanguages = undefined;
	public organizationId?: string = undefined;
	public readBy?: string = undefined;
	public readDate?: Date = undefined;
	public subject?: NotificationLanguages = undefined;
	public tenantId?: string = undefined;
}


export class NotificationAdminTMO extends NotificationBase {
	public createdBy?: string = undefined;
	public createdDate?: Date = undefined;
	public lastModifiedBy?: string = undefined;
	public lastModifiedDate?: Date = undefined;
	public sent?: boolean = undefined;
	public targetType?: NotificationTargetTypeEnum = undefined;
}

export class NotificationTMO extends NotificationBase {}

// MODEL USED IN APPLICATION (with additional properties)
export class NotificationFormBody implements NotificationFormValuesType {
	public notificationDate: Date = undefined;
	public message: NotificationLanguages = new NotificationLanguages();
	public subject: NotificationLanguages = new NotificationLanguages();
	public targetId: string = undefined;
	public targetType: NotificationTargetTypeEnum = undefined;
}

export class Notification extends NotificationTMO {
	public formBody?: NotificationFormBody = undefined;
	public etag?: string = undefined;
	public ui?: INotificationEntityEvents = {
		entityActions: {}
	};
}

export class NotificationAdmin extends NotificationAdminTMO {
	public formBody?: NotificationFormBody = undefined;
	public etag?: string = undefined;
	public ui?: INotificationEntityEvents = {
		entityActions: {}
	};
}
